<template>
    <div>
        <slot name="activator" v-bind:on="open"></slot>

        <b-modal ref="modal" title="แก้ไข" hide-footer>
            <div>
                <b-form-group label="หมายเลขติดตาม">
                    <b-form-input type="text" v-model="form.tracking_no" />
                </b-form-group>

                <div class="d-flex justify-content-end">
                    <b-btn type="button" variant="outline-secondary" @click.prevent="$refs.modal.hide()">Cancel</b-btn>
                    <b-btn type="button" variant="success" class="ml-2" @click.prevent="onSave" :disabled="saving || form.tracking_no.length === 0">Save</b-btn>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
    export default {

        props: {
            tracking: {
                type: Object,
                required: true
            }
        },

        data: () => ({
            saving: false,
            form: {
                tracking_no: ''
            }
        }),

        methods: {
            open() {
                this.$refs.modal.show()
            },

            close() {
                this.$refs.modal.hide()
            },

            async onSave() {
                this.saving = true

                try {
                    await axios.patch(`/tracking/${this.$props.tracking.id}`, {
                        action: 'tracking-no',
                        ...this.form
                    })

                    this.close()
                    window.location.reload()
                } catch (e) {
                    window.alert(e.message)
                }

                this.saving = false
            }
        }
    }
</script>
